import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  private resetCaptchaSubject$ =  new BehaviorSubject<number | undefined>(undefined);

  constructor() { }

  resetCaptcha(captchaId: number): void {
    this.resetCaptchaSubject$.next(captchaId);
  }

  getResetCaptcha$(): Observable<number | undefined> {
    return this.resetCaptchaSubject$.asObservable();
  }
}
